import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { FilterNewsPage } from './filter-news';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  declarations: [
    FilterNewsPage,
  ],
  imports: [
    IonicPageModule.forChild(FilterNewsPage), TranslateModule.forChild(),
  ],
  entryComponents: [FilterNewsPage],
})
export class FilterNewsPageModule {}



// WEBPACK FOOTER //
// ./src/modals/filter-news/filter-news.module.ts